import FOOTERLINKS, { FAQs } from '../footerLinks'
import {
  Welcome,
  Summary,
  Family,
  Eligibility,
  Content,
  AboutYou,
} from '@/types/partnerConfig'

interface LocalisedStep<T> {
  [key: string]: T
}

const WELCOME: LocalisedStep<Welcome> = {
  enUS: {
    title: 'Welcome',
    stepperLabel: 'Welcome',
    copy: ['Babylon provides 24/7 healthcare for you and your family'],
  },
  esUS: {
    title: 'Bienvenido/a a Babylon',
    stepperLabel: 'Bienvenido',
    copy: (planName: string) => [
      `Obtenga atención médica gratuita en cualquier momento usando su teléfono a través de ${planName}. Pueden aplicarse tarifas por datos.`,
    ],
  },
}

const ABOUT_YOU: LocalisedStep<AboutYou> = {
  enUS: {
    title: 'About you',
    stepperLabel: 'About you',
  },
  esUS: {
    title: 'Registrarse',
    stepperLabel: 'Registrarse',
    copy: [
      'Ingrese su información para acceder a los servicios a través de la aplicación de Babylon.',
    ],
  },
}

const FAMILY: LocalisedStep<Family> = {
  enUS: {
    title: 'Add Family Members',
    stepperLabel: 'Family',
    copy: [
      'Add your family members so they can have access to Babylon’s services',
    ],
  },
  esUS: {
    title: 'Agregue a los miembros de su familia',
    stepperLabel: 'Familia',
    copy: [
      'Agregue a los miembros de su familia para que tengan acceso a los servicios de Babylon',
    ],
  },
}

const ELIGIBILITY: LocalisedStep<Eligibility> = {
  enUS: {
    stepperLabel: 'Eligibility',
  },
  esUS: {
    stepperLabel: 'Elegibilidad',
  },
}

const SUMMARY: LocalisedStep<Summary> = {
  enUS: {
    title: 'Download the app',
    stepperLabel: 'Thank You',
    copy: [
      'Download and sign in to book a video appointment at no cost through your health plan.',
    ],
    imgUrl: '/images/babylon-ios-app.png',
    dnaV2DesignImgUrl: '/images/babylon-ios-app-us.png',
    cta: {
      showDownloadButtons: true,
      label: 'Questions? Contact us →',
      link: FAQs.USA,
    },
  },
  esUS: {
    title: 'Descargar la aplicación',
    stepperLabel: 'Descargar la aplicación',
    copy: [
      'Descargar e iniciar sesión para programar una cita por video sin costo a través de su plan médico.',
    ],
    imgUrl: '/images/babylon-ios-app.png',
    dnaV2DesignImgUrl: '/images/babylon-ios-app-us.png',
    cta: {
      showDownloadButtons: true,
      label: '¿Tiene preguntas? Comuníquese con nosotros →',
      link: FAQs.USA,
    },
  },
}

export const premadeContent = {
  WELCOME,
  ABOUT_YOU,
  FAMILY,
  SUMMARY,
  ELIGIBILITY,
}

const defaultContent: Content = {
  'en-US': {
    steps: [WELCOME.enUS, ABOUT_YOU.enUS, SUMMARY.enUS],
    footerLinks: FOOTERLINKS.USA,
  },
  'es-US': {
    steps: [WELCOME.esUS, ABOUT_YOU.esUS, SUMMARY.esUS],
    footerLinks: FOOTERLINKS.USA,
  },
}

const contentWithFamily: Content = {
  'en-US': {
    steps: [WELCOME.enUS, ABOUT_YOU.enUS, FAMILY.enUS, SUMMARY.enUS],
    footerLinks: FOOTERLINKS.USA,
  },
  'es-US': {
    steps: [WELCOME.esUS, ABOUT_YOU.esUS, FAMILY.esUS, SUMMARY.esUS],
    footerLinks: FOOTERLINKS.USA,
  },
}

const contentWithEligibility: Content = {
  'en-US': {
    steps: [WELCOME.enUS, ABOUT_YOU.enUS, ELIGIBILITY.enUS, SUMMARY.enUS],
    footerLinks: FOOTERLINKS.USA,
  },
  'es-US': {
    steps: [WELCOME.esUS, ABOUT_YOU.esUS, ELIGIBILITY.esUS, SUMMARY.esUS],
    footerLinks: FOOTERLINKS.USA,
  },
}

const contentWithFamilyAndEligibility: Content = {
  'en-US': {
    steps: [
      WELCOME.enUS,
      ABOUT_YOU.enUS,
      FAMILY.enUS,
      ELIGIBILITY.enUS,
      SUMMARY.enUS,
    ],
    footerLinks: FOOTERLINKS.USA,
  },
  'es-US': {
    steps: [
      WELCOME.esUS,
      ABOUT_YOU.esUS,
      FAMILY.esUS,
      ELIGIBILITY.esUS,
      SUMMARY.esUS,
    ],
    footerLinks: FOOTERLINKS.USA,
  },
}

export { contentWithFamily }
export { contentWithEligibility }
export { contentWithFamilyAndEligibility }
export default defaultContent
